import React from 'react'
import Grid from '@material-ui/core/Grid/index'
import StatBloc from '../../../../common/stat/StatBloc'
import { ReactComponent as Gauge } from '../../../../../icons/gauge.svg'
import TimelapseIcon from '@material-ui/icons/Timelapse'
import GroupIcon from '@material-ui/icons/Group'
import ListIcon from '@material-ui/icons/List'
import HowToRegIcon from '@material-ui/icons/HowToReg'
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck'
import { colors } from '../../../../../utils/constants'
import { useTheme } from '@material-ui/core'
import { getPourcentageCouleur } from '../../../besoinsProduction/component/resultat/OngletResultatEcartCulture'

const Stats = ({ datas, legendNbWeeks }) => {
	const theme = useTheme()

	const getPrimaryColor = () => {
		return theme.palette.primary.main
	}

	/**
	 * si un simple pourcentage est au dessus de 80 on renvoie color error sinon primary
	 * @param pourcentage le %
	 * @returns {string} la couleur
	 */
	const getPourcentageCouleurSimple = (pourcentage) => {
		if (pourcentage < 60) {
			return colors.error
		} else if (pourcentage < 80) {
			return colors.warning
		} else {
			return getPrimaryColor()
		}
	}

	return (
		<>
			<Grid container item spacing={2}>
				<Grid container item justify="flex-end" xs={6}>
					<StatBloc
						Icon={Gauge}
						values={{ 0: datas.capaciteTotale }}
						baseMessage="gestionTaches.ecranSynthese.stats.capaciteTotale"
						unite="h"
						getPourcentageCouleur={getPrimaryColor}
						withHelp
					/>
				</Grid>
				<Grid container item justify="flex-start" xs={6}>
					<StatBloc
						Icon={TimelapseIcon}
						values={{ 0: datas.chargeTotale }}
						baseMessage="gestionTaches.ecranSynthese.stats.chargeTotale"
						getPourcentageCouleur={getPrimaryColor}
						unite="h"
						helpValues={{ nbWeeks: legendNbWeeks }}
						withHelp
					/>
				</Grid>
			</Grid>
			<Grid container item spacing={2}>
				<Grid container item justify="flex-end" xs={6}>
					<StatBloc
						Icon={GroupIcon}
						values={{ 0: datas.ressourcesDispo }}
						baseMessage="gestionTaches.ecranSynthese.stats.ressourcesDispo"
						getPourcentageCouleur={getPrimaryColor}
						helpValues={{ nbWeeks: legendNbWeeks }}
						withHelp
					/>
				</Grid>
				<Grid container item justify="flex-start" xs={6}>
					<StatBloc
						Icon={HowToRegIcon}
						values={{ 0: datas.ressourcesPlanifiees }}
						baseMessage="gestionTaches.ecranSynthese.stats.ressourcesPlanifiees"
						getPourcentageCouleur={getPourcentageCouleur}
						helpValues={{ nbWeeks: legendNbWeeks }}
						isPourcentage
						withHelp
					/>
				</Grid>
			</Grid>
			<Grid container item spacing={2}>
				<Grid container item justify="flex-end" xs={6}>
					<StatBloc
						Icon={ListIcon}
						values={{ 0: datas.tachesPrevues }}
						baseMessage="gestionTaches.ecranSynthese.stats.tachesPrevues"
						getPourcentageCouleur={getPrimaryColor}
						helpValues={{ nbWeeks: legendNbWeeks }}
						withHelp
					/>
				</Grid>
				<Grid container item justify="flex-start" xs={6}>
					<StatBloc
						Icon={PlaylistAddCheckIcon}
						values={{ 0: datas.tachesPlanifieesValeur, 1: datas.tachesPlanifieesPourcentage }}
						baseMessage="gestionTaches.ecranSynthese.stats.tachesPlanifiees"
						colorParam={getPourcentageCouleurSimple(datas.tachesPlanifieesPourcentage)}
						helpValues={{ nbWeeks: legendNbWeeks }}
						withHelp
					/>
				</Grid>
			</Grid>
		</>
	)

}

export default Stats